export const NUMBER_ONLY_REGEX = "^[0-9]*$";

export const DECIMAL_REGEX = /^\d*(\.\d{0,2})?$/;

export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/;
